import { useMemo } from "react";

import DOMPurify from "dompurify";

import { applySvgColors } from "../../utils/svgColorReplace";

import styles from "./ThemedSvg.module.scss";

import type { ThemedSvgProps } from "./types";

const DEFAULT_SIZE = 80;
const DEFAULT_PRIMARY_COLOR = "RGBA(var(--theme-rgb-primary), 0.2)";
const DEFAULT_SECONDARY_COLOR = "var(--theme-primary)";

const ThemedSvg = ({
  iconSvg,
  primaryColor = DEFAULT_PRIMARY_COLOR,
  secondaryColor = DEFAULT_SECONDARY_COLOR,
  size = DEFAULT_SIZE,
}: ThemedSvgProps) => {
  const processedSvg = useMemo(() => {
    if (!iconSvg) return "";
    return applySvgColors(iconSvg, primaryColor, secondaryColor);
  }, [iconSvg, primaryColor, secondaryColor]);

  const purifiedSvg = useMemo(() => {
    if (!processedSvg) return "";
    return DOMPurify.sanitize(processedSvg, {
      USE_PROFILES: { svg: true, svgFilters: true },
    });
  }, [processedSvg]);

  if (!purifiedSvg) return null;

  return (
    <div className={styles.svgWrapper}>
      <div
        style={{ width: size, height: size }}
        dangerouslySetInnerHTML={{ __html: purifiedSvg }}
      />
    </div>
  );
};

export default ThemedSvg;
